import { clearQuotationListCache } from "../services/quotationList";
import axios from "axios";

const instance = axios.create({
  // api.jm-interim.com n'a pas d'enregistrement DNS. L'API répond sur le port 3000.
  baseURL: process.env.REACT_APP_API_URL || "https://admin.jm-interim.com:3000",
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Invalidate the short list cache whenever a quote is saved or removed.
instance.interceptors.response.use(response => {
  if (["post", "patch", "put", "delete"].includes(response.config?.method?.toLowerCase()) && /(?:^|\/)quotation(?:\/|$)/.test(response.config?.url || "")) clearQuotationListCache();
  return response;
});

/* instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      // Handle 403 Forbidden error by redirecting to the login page
      // Replace '/login' with the actual login page URL
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
); */

export default instance;
